import React from 'react';
import { clsx } from 'clsx';

/** A pulsing placeholder where a figure is still loading; `className` sizes it. */
export const ValueSkeleton: React.FC<{ className?: string }> = ({ className }) => (
  <span
    data-testid="value-skeleton"
    aria-hidden="true"
    className={clsx('inline-block flex-shrink-0 rounded bg-slate-200 motion-safe:animate-pulse', className)}
  />
);
